<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Select Core Fields For Campaign</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <form-wizard
        color="rgba(var(--vs-dark), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        @on-complete="formSubmitted"
      >
        <tab-content
          title="Choose Campaign"
          class="mb-5 mt-10"
          :before-change="beforeTabSwitch"
        >
          <!-- tab 1 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <div class="vx-col sm:w-1/6 w-full mb-6">
              <h5>Choose Campaign :</h5>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-6">
              <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="selectCampaign"
              ></CampaignAutocomplete>
              <span class="text-danger text-sm mt-5" v-show="campaign_required"
                >{{ campaign_required }}
              </span>
            </div>
          </div>
        </tab-content>

        <tab-content title="Account Core Fields" class="mb-5 mt-10">
          <!-- tab 2 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Account Core Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="account_core_fields"
              :destination="selectedAccountCoreFields"
              label="name"
              @onChangeList="onAccountCoreFieldChangeList"
            />
          </div>
        </tab-content>
        <tab-content title="Contact Core Fields" class="mb-5 mt-10">
          <!-- tab 3 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Contact Core Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="contact_core_fields"
              :destination="selectedContactCoreFields"
              label="name"
              @onChangeList="onContactCoreFieldChangeList"
            />
          </div>
        </tab-content>
      </form-wizard>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
// import vMultiselectListbox from "vue-multiselect-listbox";
// import "vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss";
// Vue.component("v-multiselect-listbox", vMultiselectListbox);
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";
export default {
  data() {
    return {
      campaign_required: null,
      companySearchComponentKey: 0,
      selected_campaign: null,
      selectedAccountCoreFields: [],
      selectedContactCoreFields: [],
      account_core_fields: [
        {
          name: "company",
          value: "company",
          label: "Company",
          type: "text"
        },
        {
          name: "actual_account_name",
          value: "actual_account_name",
          label: "Actual Account Name",
          type: "text"
        },
        {
          name: "registered_office_address_1",
          value: "registered_office_address_1",
          label: "Registered Office Address 1",
          type: "text"
        },
        {
          name: "registered_office_address_2",
          value: "registered_office_address_2",
          label: "Registered Office Address 2",
          type: "text"
        },
        {
          name: "registered_office_address_3",
          value: "registered_office_address_3",
          label: "Registered Office Address 3",
          type: "text"
        },
        {
          name: "registered_office_city",
          value: "registered_office_city",
          label: "Registered Office City",
          type: "text"
        },
        {
          name: "registered_office_county",
          value: "registered_office_county",
          label: "Registered Office County",
          type: "text"
        },
        {
          name: "registered_office_postcode",
          value: "registered_office_postcode",
          label: "Registered Office Postcode",
          type: "text"
        },
        {
          name: "registered_office_country",
          value: "registered_office_country",
          label: "Registered Office Country",
          type: "text"
        },
        {
          name: "head_office_address_1",
          value: "head_office_address_1",
          label: "Head Office Address 1",
          type: "text"
        },
        {
          name: "head_office_address_2",
          value: "head_office_address_2",
          label: "Head Office Address 2",
          type: "text"
        },
        {
          name: "head_office_address_3",
          value: "head_office_address_3",
          label: "Head Office Address 3",
          type: "text"
        },
        {
          name: "head_office_city",
          value: "head_office_city",
          label: "Head Office City",
          type: "text"
        },
        {
          name: "head_office_county",
          value: "head_office_county",
          label: "Head Office County",
          type: "text"
        },
        {
          name: "head_office_postcode",
          value: "head_office_postcode",
          label: "Head Office Postcode",
          type: "text"
        },
        {
          name: "head_office_country",
          value: "head_office_country",
          label: "Head Office Country",
          type: "text"
        },
        {
          name: "satellite_office_address_1",
          value: "satellite_office_address_1",
          label: "Satellite Office Address 1",
          type: "text"
        },
        {
          name: "satellite_office_address_2",
          value: "satellite_office_address_2",
          label: "Satellite Office Address 2",
          type: "text"
        },
        {
          name: "satellite_office_address_3",
          value: "satellite_office_address_3",
          label: "Satellite Office Address 3",
          type: "text"
        },
        {
          name: "satellite_office_city",
          value: "satellite_office_city",
          label: "Satellite Office City",
          type: "text"
        },
        {
          name: "satellite_office_county",
          value: "satellite_office_county",
          label: "Satellite Office County",
          type: "text"
        },
        {
          name: "satellite_office_postcode",
          value: "satellite_office_postcode",
          label: "Satellite Office Postcode",
          type: "text"
        },
        {
          name: "satellite_office_country",
          value: "satellite_office_country",
          label: "Satellite Office Country",
          type: "text"
        },
        {
          name: "company_registration_number",
          value: "company_registration_number",
          label: "Company Registration Number",
          type: "text"
        },
        {
          name: "company_category",
          value: "company_category",
          label: "Company Category",
          type: "text"
        },
        {
          name: "registration_jurisdiction",
          value: "registration_jurisdiction",
          label: "Registration Jurisdiction",
          type: "text"
        },
        {
          name: "revenue",
          value: "revenue",
          label: "Revenue",
          type: "text"
        },
        {
          name: "no_of_employees",
          value: "no_of_employees",
          label: "No of Employees",
          type: "text"
        },
        {
          name: "parent",
          value: "parent",
          label: "Parent",
          type: "text"
        },
        {
          name: "vertical",
          value: "vertical",
          label: "Vertical",
          type: "text"
        },
        {
          name: "sic_code",
          value: "sic_code",
          label: "SIC Code",
          type: "text"
        },
        {
          name: "website",
          value: "website",
          label: "Website",
          type: "text"
        },
        {
          name: "linkedin",
          value: "linkedin",
          label: "Social Media",
          type: "text"
        }
        ,
        {
          name: "switchboard_phone_code",
          value: "switchboard_phone_code",
          label: "Switchboard Phone Code",
          type: "text"
        },
        {
          name: "switchboard",
          value: "switchboard",
          label: "Switchboard",
          type: "text"
        },
        {
          name: "site_switchboard_phone_code",
          value: "site_switchboard_phone_code",
          label: "Site Switchboard Phone Code",
          type: "text"
        },
        {
          name: "site_switchboard",
          value: "site_switchboard",
          label: "Site Switchboard",
          type: "text"
        },
        {
          name: "phone",
          value: "phone",
          label: "Phone",
          type: "text"
        },
        {
          name: "phone_code",
          value: "phone_code",
          label: "Phone Code",
          type: "text"
        },
         //  {
        //   name: "notes",
        //   value: "notes",
        //   label: "notes",
        //   type: "text"
        // }
      ],
      contact_core_fields: [
        {
          name: "title",
          value: "title",
          label: "Title",
          type: "text"
        },
        {
          name: "forename",
          value: "forename",
          label: "Forename",
          type: "text"
        },
        {
          name: "surname",
          value: "surname",
          label: "Surname",
          type: "text"
        },
        {
          name: "job_title",
          value: "job_title",
          type: "text",
          label: "Job Title"
        },
        {
          name: "email",
          value: "email",
          type: "text",
          label: "Email"
        },
        {
          name: "ddi_phone_code",
          value: "ddi_phone_code",
          type: "text",
          label: "DDI Phone Code"
        },
        {
          name: "ddi",
          value: "ddi",
          type: "text",
          label: "DDI"
        },
        {
          name: "mobile_phone_code",
          value: "mobile_phone_code",
          type: "text",
          label: "Mobile Phone Code"
        },
        {
          name: "mobile",
          value: "mobile",
          type: "text",
          label: "Mobile"
        },
        {
          name: "social_media",
          value: "social_media",
          type: "text",
          label: "Social Media"
        },
        {
          name: "role",
          value: "role",
          type: "text",
          label: "Role"
        },
        {
          name: "sub_role",
          value: "sub_role",
          type: "text",
          label: "Sub Role"
        },
        {
          name: "seniority",
          value: "seniority",
          type: "text",
          label: "Seniority"
        }
      ]
    };
  },
  methods: {
    onAccountCoreFieldChangeList: function({ source, destination }) {
      this.account_core_fields = source;
      this.selectedAccountCoreFields = destination;
    },
    onContactCoreFieldChangeList: function({ source, destination }) {
      this.contact_core_fields = source;
      this.selectedContactCoreFields = destination;
    },
    formSubmitted() {
      this.addAccountCoreFieldsToCampaign();
      this.$router.go(-1);

      // alert("Form submitted!");
    },
    goBack: function() {
      this.$router.go(-1);
    },
    beforeTabSwitch: function() {
      if (this.selected_campaign != null) {
        return true;
      } else {
        this.campaign_required = "Please select a campaign to proceed.";
        return false;
      }
    },
     getSelectedAccountCoreFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountCoreFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);
          if(result.length != 0){
            let selected_column = JSON.parse(result[0]['selected_column']);

            selected_column.forEach(function(ele) {
              let newObj = {}
              newObj.name = ele;
              newObj.field_name = ele;
              self.selectedAccountCoreFields.push(newObj);
            });
          }

          self.account_core_fields = self.account_core_fields.filter(
            ({ name: id1 }) =>
              !self.selectedAccountCoreFields.some(
                ({ name: id2 }) => id2 === id1
              )
          );
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSelectedContactCoreFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedContactCoreFields",
          selected_campaign_id
        )
        .then(response => {


          let result = JSON.parse(response.data);
          if(result.length != 0){
            let selected_column = JSON.parse(result[0]['selected_column']);

            selected_column.forEach(function(ele) {
              let newObj = {}
              newObj.name = ele;
              newObj.field_name = ele;
              self.selectedContactCoreFields.push(newObj);
            });
          }
          self.contact_core_fields = self.contact_core_fields.filter(
            ({ name: id1 }) =>
              !self.selectedContactCoreFields.some(
                ({ name: id2 }) => id2 === id1
              )
          );
         
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    addAccountCoreFieldsToCampaign() {
      let self = this;
      let coreAccountData = [];
      self.selectedAccountCoreFields.forEach(element => {
        let coreAccountObj = {};
        coreAccountObj.field_name = element.name;
        coreAccountObj.campaign_id = self.selected_campaign.id;
        coreAccountData.push(coreAccountObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/addAccountCoreFieldsToCampaign",
          coreAccountData
        )
        .then(res => {
          self.addContactCoreFieldsToCampaign()

        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addContactCoreFieldsToCampaign() {
      let self = this;
      let coreContactData = [];
      self.selectedContactCoreFields.forEach(element => {
        let coreContactObj = {};
        coreContactObj.field_name = element.name;
        coreContactObj.campaign_id = self.selected_campaign.id;
        coreContactData.push(coreContactObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/addContactCoreFieldsToCampaign",
          coreContactData
        )
        .then(res => {
          if(res.data.status == 'fail'){
            self.$vs.notify({
              color: "danger",
              title: "Selected Field for Campaign",
              text: res.data.message
            });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    selectCampaign() {
      let self = this;
      self.selected_campaign =
        moduleCampaignManagement.selected_campaign_and_client;
      if (self.selected_campaign != null) {
        this.campaign_required = null;
      }
      self.getSelectedAccountCoreFields();
          self.getSelectedContactCoreFields();
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
              
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  components: {
    FormWizard,
    TabContent,
    CampaignAutocomplete,
    DualListBox
  }
};
</script>
<style>
.msl-search-list-input {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}

.msl-searchable-list__item {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}
.msl-multi-select__actions {
  font-size: 25px;
}

.msl-multi-select {
  width: 100%;
}
</style>
